/**
 * Created by shubham on 8/5/18.
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {FileUploadListPageData} from "./fileUploadList-datatable/fileUploadList-page-data";
import {FileUploadListDashboard} from "./fileUploadList-datatable/fileUploadList-dashboard";
import {FileUploadListPage} from "./fileUploadList-datatable/fileUploadList-page";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class FileUploadListDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    adminDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: FileUploadListPage,listData): Observable<FileUploadListPageData<FileUploadListDashboard>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: FileUploadListPage): FileUploadListPageData<FileUploadListDashboard> {
        let pageData = new FileUploadListPageData<FileUploadListDashboard>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new FileUploadListDashboard(jsonObj['id'], jsonObj['type'], jsonObj['countryName'],
                        jsonObj['businessUnitName'], jsonObj['includesHeader'], jsonObj['csvName'], jsonObj['csvUrl'],
                        jsonObj['status'], jsonObj['error'], jsonObj['message'], jsonObj['uploadBy'], jsonObj['uploadedAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/fileUploadListDashboardResultService.ts